<script lang="ts">
  import {getContext, onMount, onDestroy} from 'svelte';
  import {parse} from 'query-string';
  import {IMAGES, IMAGES_NEWS} from '@/const/images';
  import {PATHS} from '@/const/paths';
  import {LINKS} from '@/const/link';
  import {isLogin$} from '@/streams/auth';
  import {SERVICES} from '@/const/services';
  import {mockUtil} from '@/helper/moc';
  import {fixLink$, lang$} from '@/store/lang';
  import {channelWeight$} from '@/modules/buy-crypto/stream';
  import {promotions$, stickyPromotions$} from '../stream';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import MocHeaderMenu from '@/modules/moc/HeaderMenu.svelte';
  import BuyCryptoDropDown from '../popups/buy-crypto/BuyCryptoDropDown.svelte';
  import SpotDropDown from '../popups/spot/SpotDropDown.svelte';
  import ContractDropDown from '../popups/contract/ContractDropDown.svelte';
  import LearnDropDown from '../popups/learn/LearnDropDown.svelte';
  import PromotionsDropDown from '../popups/promotions/PromotionsDropDown.svelte';
  import EarnDropDown from '../popups/earn/EarnDropDown.svelte';
  import Web3Down from '../popups/web3/Web3Down.svelte';
  import {navPathnameRelationMap} from '../const';
  import lang from '../Header.lang';
  import {element$} from '../popups/meme-guide/streams';

  export let isTop = false;
  export let useContractMenu = false;

  const LG = getContext('LG');
  const placement = 'bottom-start';
  const modifiers = [
    {
      name: 'offset',
      options: {
        offset: [0, 0],
      },
    },
    {
      name: 'preventOverflow',
      options: {
        padding: 40,
      },
    },
  ];

  const hoverBGColor = '#1A1D1F';
  const hoverColor = '#fff';
  const color = '#fff';

  let isMock = mockUtil.isMock();
  let homeLink = '';
  let innerWidth = 1600;
  let isZeroFree = false;
  let logoUrl;
  let pathname;
  let leftCon;
  let showOverflow = false;
  let activeKey = '';
  let isSubset = false;

  $: pathname = process.browser && window.location.pathname;
  $: promotionsLinks = $promotions$.map((o) => o.link);
  $: isPromotions = process.browser && (promotionsLinks.includes(pathname) || promotionsLinks.includes(window.location.origin + pathname));
  $: process.browser && updatePathname(isPromotions, pathname);
  $: updateHomeLink($lang$, $channelWeight$);
  $: logoUrl = updateLogo(isTop, useContractMenu);
  $: leftCon && observeMenu(leftCon);

  onMount(function checkOverflow() {
    let i = 0;
    const times = 10;
    const period = 500;
    const id = setInterval(() => {
      if (i > times || showOverflow) {
        clearInterval(id);
        return;
      }
      showOverflow = leftCon && leftCon.scrollWidth > leftCon.clientWidth;
      i++;
    }, period);
  });

  onMount(() => {
    const spotMenuEle = document.querySelector<HTMLElement>('.meme-guide');
    element$.next(spotMenuEle);
  });

  function updatePathname(isPromotions, pathname) {
    if (isPromotions || !pathname) {
      activeKey = '';
      return;
    }
    let pathname2 = pathname;
    if (pathname.startsWith('/' + $lang$)) {
      pathname2 = pathname.replace(`/${$lang$}`, '');
    }

    if (navPathnameRelationMap.has(pathname2)) {
      const cur = navPathnameRelationMap.get(pathname2);
      if (cur.length === 1) {
        activeKey = cur[0].navKey;
        return;
      }
      if (cur.length > 1) {
        const query = parse(window.location.search);
        const queryStrArr = convertQueryStr(query);
        const nav = cur.find((item) => {
          const queryStrArr2 = convertQueryStr(item.query);
          return queryStrArr2.every((o) => queryStrArr.includes(o));
        });
        activeKey = nav ? nav.navKey : cur[0].navKey;
        return;
      }
    }
    const pathnames = Array.from(navPathnameRelationMap.keys()).sort((a, b) => (a > b ? -1 : 1));
    const pn = pathnames.find((item) => pathname2.startsWith(item)) || '';
    activeKey = pn ? navPathnameRelationMap.get(pn)[0].navKey : '';
  }

  function convertQueryStr(query) {
    return Object.keys(query).map((key) => `${key}=${query[key]}`);
  }

  function observeMenu(observedElement) {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        showOverflow = entry.target.scrollWidth > entry.target.clientWidth;
      }
    });

    resizeObserver.observe(observedElement);

    onDestroy(() => observedElement && resizeObserver.unobserve(observedElement));
  }

  function scrollMenu() {
    leftCon.scrollBy({
      left: 100,
      behavior: 'smooth',
    });
  }

  function updateHomeLink(lang, channelWeight) {
    if (channelWeight.length > 0) {
      isZeroFree = channelWeight.some((o) => (o.weight & Math.pow(2, 20)) > 0);
    }
    homeLink = SERVICES.BASE_URL + (lang === 'en' ? '' : '/' + lang);
  }

  function updateLogo(isTop, useContractMenu) {
    // 导航栏仅需要dark主题
    return IMAGES.LOGO_LIGHT;
  }

  function checkActive(key) {
    return key === activeKey;
  }

  function handleMenuHover(e) {
    isSubset = e.detail;
  }

  // 模拟鼠标移入
  function simulateMouseenter(elemName) {
    return () => {
      const time = isSubset ? 0 : 150;
      // menu translate过渡时间为100ms
      let timer = setTimeout(() => {
        // 获取目标 DOM 元素
        const targetElement = document.querySelector(`.${elemName}`);
        targetElement.classList.add('active');
        // 创建 mouseenter 事件
        const mouseEnterEvent = new MouseEvent('mouseenter', {
          bubbles: true,
          cancelable: true,
          clientX: targetElement.getBoundingClientRect().left + 10, // 模拟鼠标位置
          clientY: targetElement.getBoundingClientRect().top + 10,
        });
        // 触发 mouseenter 事件
        targetElement.dispatchEvent(mouseEnterEvent);
        clearTimeout(timer);
        timer = null;
      }, time);
    };
  }
</script>

<style>
  .menu {
    position: relative;
    padding: 0 20px;
    line-height: 56px;
    color: #fff;
  }
  .top .menu {
    color: #fff;
  }
  .menu:hover,
  .active {
    background: #202429;
  }
  .hot-img {
    width: 14px;
    height: 16px;
  }
  .title-icon {
    margin-left: 4px;
    height: 14px;
  }
  .trigger {
    position: relative;
    padding: 0 12px;
    line-height: 56px;
    font-weight: 500;
    font-size: 14px;
  }
  .left-con {
    max-width: calc(max(100vw, 1280px) - 690px);
    /*flex: 1;*/
    overflow: auto hidden;
  }
  .overflow-icon {
    top: 0;
    right: 0;
    z-index: 100;
    width: 36px;
    height: 56px;
    line-height: 64px;
    color: var(--menu-dark);
    transform: translateY(-3px);
  }
  .top .overflow-icon {
    color: var(--menu-dark);
  }
  .special-menu {
    padding: 0 12px;
  }
  .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .no-scroll-bar::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }
  .trigger.active .title {
    color: var(--hoverColor);
  }
  .trigger.active + :global(i) {
    color: var(--hoverColor);
  }
  .main :global(.tooltip-wrap) {
    margin-left: 0;
  }
  .main :global(.tooltip-wrap .auto-scroll) {
    border-radius: 0 0 12px 12px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
  }
  .main :global(.contract-market-menu .auto-scroll),
  .main :global(.spot-market-menu .auto-scroll) {
    border-bottom-left-radius: 0;
    box-shadow: none;
  }
  .logo {
    width: 102px;
    height: 24px;
  }
</style>

<svelte:window bind:innerWidth />

<div class="main df aic left-new" class:top={isTop}>
  <a class="df mt2" href={homeLink} target="_self">
    <img class="logo" height="24" alt="Logo" src={logoUrl} />
  </a>
  <div bind:this={leftCon} class="left-con ml24 df aic no-scroll-bar" style="max-width: calc(max(100vw, 1280px) - {$isLogin$ ? 690 : 560}px)">
    {#if isMock}
      <MocHeaderMenu {isTop} />
    {:else}
      <Menu {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon>
        <span slot="trigger" class="trigger df aic" class:active={checkActive('BuyCrypto')}>
          <span class="title">{LG(lang.BuyCrypto)}</span>
          {#if isZeroFree}
            <img class="title-icon" height="14" src={IMAGES_NEWS.BUY_CRYPTO_ZERO_FEE_HEADER} alt="zero fee" />
          {/if}
        </span>
        <BuyCryptoDropDown />
      </Menu>
      <Menu class="ml24" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon>
        <span on:click={() => location.assign($fixLink$(PATHS.MARKETS.pathname))} slot="trigger" class="trigger" class:active={checkActive('Markets')}>{LG(lang.Markets)}</span>
      </Menu>
      <Menu class="ml24" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon on:mouseenter={simulateMouseenter('contract-menu-usdt')}>
        <span slot="trigger" class="trigger" class:active={checkActive('Contract')}>
          <span class="title">{LG(lang.Contract)}</span>
          <img style="transform: translateY(3px)" class="title-icon" height="14" src="https://img.phemex.com/v1/fb7fb441-6fab-4400-92b0-846286eb5cb1/hot.svg" alt="hot" />
        </span>
        <ContractDropDown on:hover={handleMenuHover} />
      </Menu>
      <Menu class="ml24 meme-guide" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon on:mouseenter={simulateMouseenter('spot-menu-trade')}>
        <span slot="trigger" class="trigger" class:active={checkActive('Spot')}>
          <span class="title">{LG(lang.Spot)}</span>
        </span>
        <SpotDropDown on:hover={handleMenuHover} />
      </Menu>
      <Menu class="ml24" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon>
        <span slot="trigger" class="trigger" class:active={checkActive('Earn')}>
          <span class="title">{LG(lang.EarnMain)}</span>
        </span>
        <EarnDropDown />
      </Menu>
      <Menu class="ml24" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon>
        <span slot="trigger" class="trigger df aic" class:active={checkActive('Web3')}>
          <span class="title">{LG(lang.Web3)}</span>
        </span>
        <Web3Down />
      </Menu>
      <Menu class="ml24" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon>
        <span slot="trigger" class="trigger" class:active={checkActive('Learn')}>
          <span class="title">{LG(lang.Learn)}</span>
        </span>
        <LearnDropDown />
      </Menu>
      <Menu class="ml24" {placement} {modifiers} {color} {hoverColor} {hoverBGColor} noIcon>
        <span slot="trigger" class="trigger" class:active={isPromotions}>
          <span class="title">{LG(lang.Promotions)}</span>
        </span>
        <PromotionsDropDown />
      </Menu>
      {#if $stickyPromotions$.title}
        <a class="df aic T2 cp menu special-menu" class:active={$stickyPromotions$.link === pathname} href={$stickyPromotions$.link}>
          <span>{$stickyPromotions$.title}</span>
          {#if $stickyPromotions$.cornerIcon}
            <img class="hot-img ml4" height="16" src={$stickyPromotions$.fullCornerIcon} alt="new" />
          {/if}
        </a>
      {/if}
      {#if $lang$ === 'tr'}
        <a class="T2 cp menu special-menu" href={LINKS.PHEMEX_TR} target="_blank" rel="noopener noreferrer nofollow">
          <span>PhemexTR</span>
        </a>
      {/if}
    {/if}
  </div>

  {#if showOverflow}
    <div class="overflow-icon df jcc cp" on:click={scrollMenu}>
      <i class="iconfont f16">&#xe755;</i>
    </div>
  {/if}
</div>
